export const APP_NAME = 'NTCOG Centralized Reporting Solution';
export const APP_SHORT_NAME = 'NTCOG';
export const APP_BRAND_TITLE = 'NTCOG';
export const APP_BRAND_SUBTITLE = 'Centralized Reporting Solution';

export const LANDING_HEADLINE =
  'Advancing performance and transparency from submission to strategic impact.';

export const LANDING_TAGLINE =
  'Streamlining data capture, reporting workflows, and ministry operations into one connected experience, with clear visibility from local activity to nation oversight.';

export const LANDING_OVERVIEW_EYEBROW = 'Insight Summary';

export const LOGIN_CTA_LABEL = 'Login';
export const SIGNUP_CTA_LABEL = 'Have an invitation? Create your account';

export const FOOTER_ORG_LABEL = 'NTCOG JA';
export const SPURR_TECH_URL = 'https://spurrtech.com/';
